import {NarrowPage} from "../../elements/Pages";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import Joi from "joi";
import {Checkbox, Input, MultiSelect, Select} from "../../elements/forms/Inputs";
import Form, {baseHandleChange} from "../../elements/forms/Form";
import {FormSectionContent} from "../../elements/forms/FormLayout";
import {getCourseList} from "../../../api/courses";
import {getPublishers, getBook, postBook, patchBook} from "../../../api/books";
import {toast} from "react-toastify";

export default function BookCreateEdit() {
    const {id} = useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [data, setData] = useState({
        title: '',
        order_number: '',
        is_digital: false,
        publisher: null,
        courses: []
    });
    const [errors, setErrors] = useState({});

    const {data: publishers} = useQuery(['publishers'], getPublishers, {refetchInterval: 1000 * 60 * 60 * 24});
    const {data: courses} = useQuery(['course_list'], getCourseList, {refetchInterval: 1000 * 60 * 60 * 24});

    useEffect(() => { loadData(); }, [id]);

    async function loadData() {
        if (id) {
            const newData = await getBook(id);
            setData({
                ...newData
            });
        }
    }

    const schema = {
        title: Joi.string().required().label('Titel')
    };

    async function onSave() {
        let newData;
        if (!data.id) newData = await postBook(data);
        else newData = await patchBook(data);
        await queryClient.invalidateQueries(['books']);
        await queryClient.invalidateQueries(['books', id]);
        toast.success('Gespeichert');
        navigate(`/books/${newData.id}`);
    }

    function handleChange(evt) {
        baseHandleChange(evt, data, setData, errors, setErrors, schema);
    }

    function handleSelectCourses(values) {
        setData({...data, courses: values});
    }

    const title = data.id ? 'Buch bearbeiten' : 'Buch anlegen';

    return (
        <NarrowPage title={title}>
            <Form id="bookForm" onSave={onSave}
                  data={data} setData={setData}
                  errors={errors} setErrors={setErrors}
                  successMessage={''}
                  schema={schema}
            >
                <FormSectionContent>
                    <Input
                        path="title"
                        label="Titel"
                        className="sm:col-span-6"
                        onChange={handleChange}
                        errors={errors}
                        data={data}
                    />
                    <Input
                        path="order_number"
                        label="Bestellnr."
                        className="sm:col-span-3"
                        onChange={handleChange}
                        errors={errors}
                        data={data}
                    />
                    <Checkbox
                        path="is_digital"
                        label="Digital"
                        className="sm:col-span-3"
                        onChange={handleChange}
                        errors={errors}
                        data={data}
                    />
                    <Select
                        path="publisher"
                        label="Verlag"
                        options={publishers}
                        valueAttr="id"
                        labelAttr="name"
                        valueOnly={false}
                        onChange={handleChange}
                        errors={errors}
                        data={data}
                        className="sm:col-span-6"
                    />
                    <MultiSelect
                        path="courses"
                        label="Kurse"
                        options={courses}
                        valueAttr="id"
                        labelAttr="course_number"
                        onChange={handleSelectCourses}
                        data={data}
                        className="sm:col-span-6"
                        isClearable={true}
                        valueOnly={false}
                    />
                </FormSectionContent>
            </Form>
            <span onClick={() => navigate(-1)} className="cursor-pointer float-right mt-2 font-medium text-imsblue-600">Zurück</span>
        </NarrowPage>
    );
}
